import classNames from "classnames";
import styles from "./index.module.scss";
import VerifiedUserIcon from "../VerifiedUserIcon";
import FollowerIcon from "../FollowerIcon";
import PromoterIcon from "../PromoterIcon";
import { ReactComponent as ModeratorIcon } from "../../assets/ic-moderator.svg";

const UserBadges = ({
  username,
  isIdentityVerified,
  isSupporter,
  isMostProfitableSupporter,
  isPaid,
  isAnonymous,
  isMostProfitablePromoter,
  isPromoter,
  isModerator,
}) => {
  return (
    <div
      className={classNames(
        "d-block text-body-2 text-medium text-primary d-flex align-items-center text-truncate",
        styles.username,
      )}
    >
      {username ? (
        <span className="text-truncate notranslate">{username}</span>
      ) : null}
      <VerifiedUserIcon isVisible={isIdentityVerified} className="ms-2" />
      <FollowerIcon
        isSupporter={isSupporter}
        isFirst={isMostProfitableSupporter}
        isPaid={isPaid}
      />
      {isPromoter && (
        <PromoterIcon
          isFirst={isMostProfitablePromoter}
          isNotOnlyBadge={isSupporter}
        />
      )}
      <FollowerIcon
        isAnonymous={isAnonymous}
        isNotOnlyBadge={isSupporter || isPromoter}
      />
      {isModerator ? <ModeratorIcon className={styles.moderatorIcon} /> : null}
    </div>
  );
};

export default UserBadges;
